import React, { useEffect } from 'react';
import { useAgents } from '../hooks/use-agents';
import { AgentCard } from '../components/agents';

export function AgentRegistryPage() {
  const { agents, loading, error, fetchPublished } = useAgents();

  useEffect(() => { fetchPublished(); }, [fetchPublished]);

  if (loading) return <div className="p-8 text-center">Loading registry...</div>;
  if (error) return <div className="p-8 text-red-600">{error}</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4">
          <h1 className="text-3xl font-bold text-gray-900">Agent Registry</h1>
          <p className="text-gray-600 mt-1">Discover and use published agents</p>
        </div>
      </header>
      
      <main className="max-w-7xl mx-auto py-6 px-4">
        {agents.length === 0 ? (
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <p className="text-gray-500">No agents published yet.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {agents.map(agent => (
              <AgentCard
                key={agent.id}
                agent={agent}
                showActions={false}
              />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
